import { FooterView } from './Footer.view'

export const Footer = () => <FooterView />
